import { LOG } from './types';
export const log = (level, fields, message) => ({
  type: LOG,
  level,
  fields,
  message
});
export function debug(fields, message) {
  return dispatch => {
    dispatch(log('debug', fields, message));
  };
}
export function info(fields, message) {
  return dispatch => {
    dispatch(log('info', fields, message));
  };
}
export function warn(fields, message) {
  return dispatch => {
    dispatch(log('warn', fields, message));
  };
}
export function error(fields, message) {
  return dispatch => {
    dispatch(log('error', fields, message));
  };
}
export function fatal(fields, message) {
  return dispatch => {
    dispatch(log('fatal', fields, message));
  };
}